import styles from './SelectWidget.module.scss'
import { useEffect, useRef, useState } from 'react'
import { Form } from 'react-bootstrap'
import useOutside from '@/hooks/useOutside'
import useEscapeKey from '@/hooks/useEscapeKey'

interface Props {
  variant: 'default' | 'whiteOutline'
  open: boolean | null
  placeholder: string
  inputValue: string
  disabled: boolean
  renderWidget: () => JSX.Element
  preventCloseOnClickOutside: boolean
}
const SelectWidget = ({
  variant = 'default',
  open: openOverride,
  placeholder,
  inputValue,
  disabled = false,
  renderWidget,
  preventCloseOnClickOutside = false,
}: Props) => {
  const [open, setOpen] = useState<boolean | null>(false)

  useEffect(() => {
    setOpen(openOverride)
  }, [openOverride])

  // state handlers
  const getInputDisplayValue = () => {
    return inputValue ? inputValue : placeholder
  }
  const toggleOpen = () => {
    if (open) {
      handleClose()
    } else {
      handleOpen()
    }
  }
  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    if (open) {
      setOpen(false)
    }
  }

  // a11y hooks
  const wrapperRef = useRef(null)
  useOutside(wrapperRef, () => {
    if (!preventCloseOnClickOutside) {
      handleClose()
    }
  })
  useEscapeKey(() => {
    handleClose()
  })

  return (
    <>
      <Form.Group className={`form-group ${styles.root} ${styles[variant]}`} ref={wrapperRef}>
        <div className={`${styles.input} ${open && styles.active} ${disabled && styles.disabled}`} onClick={toggleOpen}>
          <div className={styles.label}>{getInputDisplayValue()}</div>
        </div>
        {open && <div className={styles.dropdown}>{renderWidget()}</div>}
      </Form.Group>
    </>
  )
}

export default SelectWidget
